import "@mercedes-benz/typeface-mb-corpo-a";
import "@mercedes-benz/typeface-mb-corpo-s";
import "normalize.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { DataService } from "./auth/DataService";
import { accessdenied } from "./auth/setting";
const root = ReactDOM.createRoot(document.getElementById("root"));

DataService.getAuthCode();

DataService.getAuth().then(() => {
  if (DataService.authorized() === true) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    DataService.clearStorage();
    window.location.assign(accessdenied);
  }
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
